import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const EFFECTIVE_DATE = 'August 7, 2026';
const CONTACT_EMAIL = 'craighalonen04@gmail.com';
const OPERATOR_NAME = 'Craig Halonen';

export default function TermsOfService() {
  return (
    <div className="legal-container">
      <div className="legal-nav">
        <Link to="/login">&larr; Back</Link>
      </div>
      <div className="legal-card">
        <h1>End-User License Agreement &amp; Terms of Service</h1>
        <p className="legal-updated">Effective date: {EFFECTIVE_DATE}</p>

        <p>
          This End-User License Agreement ("Agreement") is between {OPERATOR_NAME} ("we," "us,"
          "the operator") and the individual or business ("you," "User") using DesignsDesigns
          ERP (the "App"), a quote-to-work-order management system for a custom drapery and
          furniture workroom. By logging into or using the App, you agree to this Agreement.
        </p>

        <h2>1. License Grant</h2>
        <p>
          We grant you a limited, non-exclusive, non-transferable, revocable license to access
          and use the App for the internal business purposes of the workroom account you have
          been given credentials for. This license does not grant you any ownership interest in
          the App, its source code, or its underlying software.
        </p>

        <h2>2. Account &amp; Access</h2>
        <p>
          Access to the App is provided by invitation/account creation and restricted to
          authorized users of the operating workroom. You are responsible for keeping your
          login credentials confidential and for all activity that occurs under your account.
          Accounts and roles (admin, manager, worker) determine what data and functions a user
          can access within the App.
        </p>

        <h2>3. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the App for any purpose other than managing quotes, customers, and work orders for the authorized business</li>
          <li>Attempt to access data belonging to a different domain/account than your own</li>
          <li>Attempt to reverse engineer, decompile, or interfere with the App's normal operation</li>
          <li>Use the App to violate any applicable law</li>
        </ul>

        <h2>4. QuickBooks Online Integration</h2>
        <p>
          If you choose to connect the App to QuickBooks Online, you authorize the App to
          create Estimates in your QuickBooks company file from finalized quotes, and to read
          back their status when you manually trigger a sync. This integration is optional,
          user-initiated for each sync, and can be disconnected at any time from Settings. Use
          of QuickBooks Online is also subject to Intuit's own terms of service, which are
          between you and Intuit.
        </p>

        <h2>5. Data Ownership</h2>
        <p>
          All customer, quote, and work order data you enter into the App remains your (or your
          employer's) property. We do not claim ownership over your business records; we store
          and process them solely to provide the App's functionality to you.
        </p>

        <h2>6. Availability &amp; Support</h2>
        <p>
          The App is provided on an as-available basis. We will make reasonable efforts to keep
          it accessible and to fix reported issues, but we do not guarantee uninterrupted
          availability, and scheduled or emergency maintenance may occur without advance notice.
        </p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>
          THE APP IS PROVIDED "AS IS" AND "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND, EITHER
          EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF
          MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT. Pricing
          calculations, quotes, and work order outputs generated by the App should be reviewed
          by a qualified person before being relied upon commercially.
        </p>

        <h2>8. Limitation of Liability</h2>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY LAW, {OPERATOR_NAME.toUpperCase()} SHALL NOT BE
          LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR
          ANY LOSS OF PROFITS, REVENUE, DATA, OR BUSINESS OPPORTUNITY, ARISING OUT OF OR RELATED
          TO YOUR USE OF THE APP.
        </p>

        <h2>9. Termination</h2>
        <p>
          We may suspend or terminate your access to the App at any time, including if we
          believe this Agreement has been violated. You may stop using the App and request
          deletion of your account at any time by contacting us.
        </p>

        <h2>10. Changes to This Agreement</h2>
        <p>
          We may update this Agreement from time to time. The updated version will be posted at
          this URL with a revised effective date above.
        </p>

        <h2>11. Governing Law</h2>
        <p>
          This Agreement is governed by the laws of the state in which the operator resides,
          without regard to conflict-of-law principles.
        </p>

        <h2>12. Contact</h2>
        <p>
          Questions about this Agreement can be sent to{' '}
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. See also our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </p>
      </div>
    </div>
  );
}
